import { Injectable, inject } from '@angular/core';

import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import {
  DefinedTermOccurence,
  DocumentDefinedTerm,
  QueryGetDefinedTermOccurenceByTransactionIdsArgs,
  QueryGetDefinedTermsByDocumentArgs,
} from '../../../generated/graphql-models';
import { DocumentId } from '../../document-viewer/models/document-viewer.models';
import { TransactionId } from '../../market-comparison/models/column.model';
import { GraphQLService } from '../../shared/services/graphql.service';
import {
  GET_DEFINED_TERMS_BY_DOCUMENT,
  GET_DEFINE_TERM_OCCURENCE_BY_TRANSACTIONS,
} from '../constants/deal.queries';
import { DocumentDefinedTermViewModel } from '../models/document-defined-term';

@Injectable({ providedIn: 'root' })
export class TermExplorerService {
  private readonly graphQlService = inject(GraphQLService);

  public getDocumentDefinedTerms(
    documentShortName: DocumentId,
    libraryTransactionId: string
  ): Observable<DocumentDefinedTermViewModel[]> {
    return this.graphQlService
      .getManyQuery<DocumentDefinedTerm, QueryGetDefinedTermsByDocumentArgs>(
        GET_DEFINED_TERMS_BY_DOCUMENT,
        {
          documentShortName,
          libraryTransactionId,
        }
      )
      .pipe(map((terms) => terms.map((t) => ({ ...t, primaryDomOrder: +t.primaryDomOrder }))));
  }

  public getDefinedTermOccurence(
    documentShortNames: DocumentId[],
    documentTransactionIds: TransactionId[],
    transactionIds: TransactionId[]
  ): Observable<Record<string, number>> {
    if (!transactionIds?.length && !documentShortNames?.length) {
      return of({});
    }

    return this.graphQlService
      .getManyQuery<DefinedTermOccurence, QueryGetDefinedTermOccurenceByTransactionIdsArgs>(
        GET_DEFINE_TERM_OCCURENCE_BY_TRANSACTIONS,
        {
          documentShortNames,
          documentTransactionIds,
          transactionIds,
        }
      )
      .pipe(
        map((occurence) =>
          occurence.reduce<Record<string, number>>((acc, curr) => {
            acc[curr._id] = curr.occurence;
            return acc;
          }, {})
        )
      );
  }
}
